export const meshDevicePath = (nodeId: string) => `/meshcentral/device/${encodeURIComponent(nodeId)}`;

export const meshNodeIdFromPath = (value?: string) => {
  if (!value) return '';
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};
